module.exports = __webpack_public_path__ + "img/zola-360px.487eed74.png";